<template lang="pug">
  modal(v-on="$listeners")
    template(slot="header")
      h3.reader-show(tabindex="0") Details & Sizing
      h6 {{ product.vendor }}<br>{{ product.title.replace(product.vendor + ' ', '') }}
    //- shopify description
    section.product-size-guide-modal__body.product-size-guide-modal__body--shopify.flex.flex-wrap.justify-between.bulleted-sub-lists.overflow-x-scroll(v-html="product.descriptionHtml")
    //- (size conversion by product type)
    section.product-size-guide-modal__body(v-if="sizingTable")
      h4 Size Conversion
      table
        tbody
          tr(v-for="row in sizingTable")
            td(v-for="cell in row.split(',')") {{ cell }}
    //- contact
    footer.text-15.md-text-13.mt-em(v-if="contact")
      wp-rich-text(:html="contact")
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ProductSizeGuideOverlay',
  props: ['product'],
  computed: {
    ...mapState({
      sizeGuides: state => (state.site && state.site.hostem_size_guides) || [],
      contact: state => state.site && state.site.hostem_size_guide_footer
    }),
    sizingTable () {
      const guide = this.sizeGuides.find(gd => gd.product_types.find(itm => this.product.productType.split(',').includes(itm.type)))
      return guide && guide.table && guide.table.split('\n')
    }
  }
}
</script>

<style>
@import '../../style/_settings.css';

/* mobile / base */
.product-size-guide-modal__body{
  /* hide paragraphs (shown in product body) */
  & > p{
    display: none;
  }
  & > *{
    @apply w-full;
  }
  /* smaller font-size elements */
  & table, & ul ul{
    @apply text-11 mb-60 mt-12;
    /*margin-bottom: calc(60 / 17 * 1em);*/
  }
  /* headings */
  & :--heading{
    /*margin-bottom: calc(30/17 * 1em);*/
    @apply mb-30;
  }
  /* sub list spacing from list "header" */
  & ul ul{
    /*margin-top: 1.15em;*/
    /*@apply mt-12;*/
  }
  /* table styling */
  & table {
    width:auto !important;
    min-width:100%;
    /*@apply mt-12;*/
    & td {
      @apply border-app-border border px-8 pt-5;
      &:nth-child(n+2){
        @apply text-right
      }
    }
  }
  /* table: no borders on first-cell... */
  &.product-size-guide-modal__body--shopify table {
    & tr:first-child td:first-child{ @apply border-t-0 border-l-0 }
  }
}

/* tablet+ */
@media (--bkpt-md) {
  .product-size-guide-modal__body{
    /* lists 50% width so they column */
    & > ul, & > ol{
      max-width:calc(300 / 17 * 1em);
      /*@apply w-1x2 pr-20*/
    }
    /* smaller font-size elements */
    & table, & ul ul{
      @apply text-13
    }
  }
}
</style>
